<template>
  <!-- PDF 预览弹窗 -->
  <div class="pdf-preview-container">
    <embed
        :src="currentPdfUrl"
        type="application/pdf"
        width="100%"
        height="100%"
    >
    <div class="pagination-controls">
      <el-button
          @click="changePage(-1)"
          :disabled="currentPageIndex === 0"
      >上一页
      </el-button>

      <span class="page-info">
          第 {{ currentPageIndex + 1 }} / {{ pdfFiles.length }} 个文件
      </span>

      <el-button
          @click="changePage(1)"
          :disabled="currentPageIndex === pdfFiles.length - 1"
      >下一页
      </el-button>
    </div>

  </div>


</template>

<script>
import {Plus} from "@element-plus/icons-vue";

export default {
  name: "ReimbursePdfView.vue",
  components: {Plus},
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      currentPdfUrl: '',
      currentPageIndex: 0,
      pdfFiles: [],
    };
  },
  mounted() {
    console.log(this.parentData, 'this.parentData')
    this.handleFileClick(this.parentData.fileListObj,this.parentData.index)
  },

  methods: {
    // 点击文件时触发
    handleFileClick(fileListObj,index) {
      this.pdfFiles = fileListObj
      this.currentPageIndex = index
      this.loadPdfPreview()
    },

    // 加载PDF预览
    loadPdfPreview() {
      if (!this.pdfFiles || this.pdfFiles.length === 0) {
        return
      }
      const file = this.pdfFiles[this.currentPageIndex]
      if (file.url) {
        this.currentPdfUrl = file.url
      } else {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.currentPdfUrl = e.target.result
        }
        reader.readAsDataURL(file.raw)
      }
    },

    // 翻页方法
    changePage(step) {
      const newIndex = this.currentPageIndex + step
      if (newIndex >= 0 && newIndex < this.pdfFiles.length) {
        this.currentPageIndex = newIndex
        this.loadPdfPreview()
      }
    }
  }
}
</script>

<style scoped lang="less">
.pdf-preview-container {
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: auto; /* 允许内容滚动 */
}

.pagination-controls {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.page-info {
  margin: 0 15px;
  font-weight: bold;
}

</style>